import clsx from "clsx";

import styles from "./Paper.module.css";

export interface PaperProps extends React.HTMLAttributes<HTMLDivElement> {
    /** Shadow depth. 0 = flat, any positive number = elevated. Default: 1. */
    elevation?: number;
    /** Remove border-radius (e.g. for full-screen mobile views). */
    square?: boolean;
}

export const Paper = ({
    elevation = 1,
    square = false,
    className,
    children,
    ...rest
}: PaperProps) => (
    <div
        className={clsx(
            styles.root,
            elevation > 0 && styles.elevated,
            square && styles.square,
            className
        )}
        {...rest}
    >
        {children}
    </div>
);
